import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/double-circle-radio-icon.svg'
import _imports_1 from '@/assets/circle-radio-icon.svg'


const _hoisted_1 = { class: "w-[67%]" }
const _hoisted_2 = { class: "text-base leading-[26px] tracking-[0.01rem] font-medium text-primary-text-color" }
const _hoisted_3 = {
  class: "mt-[12px] flex items-center gap-3 flex-wrap",
  role: "radiogroup"
}
const _hoisted_4 = ["disabled", "onChange", "checked"]
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = {
  src: _imports_0,
  alt: "Circle radio"
}
const _hoisted_7 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_8 = { class: "pl-2 text-sm font-normal text-primary-text-color" }
const _hoisted_9 = ["disabled", "value"]



type Props = {
  radioValue: any;
  commentValue: any;
  options: Array<string>;
  text: string;
  disabled?: boolean;
  inputClass?: string;
};

type Emits = {
  (event: "updateRadio", radioValue: any): void;
  (event: "updateComment", commentValue: any): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'RadioButtonsTextComponent',
  props: {
    radioValue: {},
    commentValue: {},
    options: {},
    text: {},
    disabled: { type: Boolean },
    inputClass: {}
  },
  emits: ["updateRadio", "updateComment"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const onRadioValueChange = (radioValue: any) => {
  emits("updateRadio", radioValue);
};

const onCommentValueChange = (event: Event) => {
  const target = event.target as HTMLTextAreaElement;

  emits("updateComment", target.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex gap-5 bg-transparent p-2 rounded-primary-radius border", __props.inputClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(__props.text), 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
          return (_openBlock(), _createElementBlock("div", { key: option }, [
            _createElementVNode("div", {
              class: _normalizeClass(["custom-radio-button flex items-center justify-between rounded-full py-[2px] px-2 border-2", `${
              props.radioValue === option
                ? 'bg-[#DDDDFB] border-transparent'
                : 'bg-transparent border-primary-text-color'
            }
              ${__props.disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
            `])
            }, [
              _createElementVNode("input", {
                disabled: __props.disabled,
                onChange: ($event: any) => (onRadioValueChange(option)),
                type: "radio",
                checked: props.radioValue === option
              }, null, 40, _hoisted_4),
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
                  [_vShow, props.radioValue === option]
                ]),
                _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
                  [_vShow, props.radioValue !== option]
                ]),
                _createElementVNode("p", _hoisted_8, _toDisplayString(option), 1)
              ])
            ], 2)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("textarea", {
      disabled: __props.disabled,
      value: props.commentValue,
      onInput: onCommentValueChange,
      placeholder: "Kommentar(Optional)",
      class: "w-[33%] text-primary-text-color text-base leading-[26px] tracking-[0.01rem] font-normal bg-[#F9F8F6] p-3 border border-[#E3E1EA] rounded-primary-radius resize-none outline-none focus:border focus:border-[#393840]"
    }, null, 40, _hoisted_9)
  ], 2))
}
}

})